export const BOOK_URL = "https://www.amazon.co.uk/Ultimate-Essay-Guide-Practical-actionable-ebook/dp/B07FKR1S2F/"